import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="bg-primary-600">
      <div className="mx-auto max-w-[1280px] px-4 py-16 text-center md:px-6 md:py-20">
        <h2 className="mx-auto max-w-2xl font-heading text-3xl font-bold text-white md:text-4xl">
          {t("cta.title")}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-primary-50">
          {t("cta.subtitle")}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-background-50 px-7 py-3.5 text-base font-semibold text-primary-700 whitespace-nowrap transition-colors hover:bg-white"
        >
          <i className="ri-external-link-line w-5 h-5 flex items-center justify-center" />
          {t("cta.button")}
        </a>
      </div>
    </section>
  );
}